<template>
  <div class="d-flex justify-end">
    <qz-btn
      v-if="isSaveBtnShown"
      color="navy-light"
      rounded
      x-large
      dark
      data-test="save_btn"
      @click.prevent="$emit('save')"
    >
      {{ saveBtnLabel }}
      <v-icon
        dark
        right
        size="22"
      >
        {{ saveBtnIcon }}
      </v-icon>
    </qz-btn>
    <qz-btn
      v-if="isCancelBtnShown"
      color="primary"
      text
      rounded
      class="ml-2"
      data-test="cancel_btn"
      x-large
      @click.prevent="$emit('clear')"
    >
      Cancel
      <template v-if="isEdit">edit</template>
    </qz-btn>
  </div>
</template>

<script>

export default {
  name: 'subform-controls',
  props: {
    productLabel: {
      type: String,
      default: null,
    },
    saveLabel: {
      type: String,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isCancelBtnShown: {
      type: Boolean,
      default: false,
    },
    isSaveBtnShown: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    saveBtnLabel () {
      return !this.isEdit ? `Add another ${this.productLabel}` : `Save ${this.productLabel} details`;
    },
    saveBtnIcon () {
      return this.isEdit ? 'mdi-content-save' : 'mdi-plus';
    },
  },
};
</script>
